/**
 * Login audit — pings the backend once after sign-in so it can record a system login event
 * (email + masked IP + Cloudflare geo + browser/device). Fire-and-forget; never blocks auth.
 */
import { getFunctionUrl } from '../utils/apiClient';

export async function recordLogin(): Promise<void> {
  try {
    const { getAuth } = await import('firebase/auth');
    const user = getAuth().currentUser;
    if (!user) return;
    const token = await user.getIdToken();
    await fetch(getFunctionUrl('recordLogin'), {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch { /* auditing is best-effort */ }
}
